import React from "react";

const Footer = () => {
  return (
    <>
      <footer className=" text-center bottom-0">
        <p className="">
          &copy; 2023 Abdullah Zubair Web Design. All Rights Reserved.
        </p>
      </footer>
    </>
  );
};

export default Footer;
